import React from 'react';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* Content Spacer - Prevents content from being hidden behind fixed footer */}
      <div style={{ 
        height: '80px', // Adjust based on your footer's actual height
        width: '100%',
        flexShrink: 0 
      }} />
      
      {/* Fixed Footer */}
      <footer style={{ 
        backgroundColor: '#f8f9fa',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '60px', // Explicit height
        padding: '0.5rem 0',
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.05)',
        zIndex: 1000, // Matches header z-index
        boxSizing: 'border-box'
      }}>
        <div 
          id="buttonGroup" 
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            maxWidth: '600px',
            margin: '0 auto',
            height: '100%'
          }} 
          role="group" 
          aria-label="Main navigation"
        >
          <NavLink 
            to="/home" 
            className={({ isActive }) => 
              `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
            }
            style={{
              background: 'transparent',
              border: 'none',
              padding: '0.5rem 1rem',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <i className="material-icons" style={{ fontSize: '1.5rem' }}>roofing</i>
              <span style={{ fontSize: '0.8rem' }}>Home</span>
            </div>
          </NavLink>

          <NavLink 
            to="/sermons" 
            className={({ isActive }) => 
              `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
            }
            style={{
              background: 'transparent',
              border: 'none',
              padding: '0.5rem 1rem',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <i className="material-icons" style={{ fontSize: '1.5rem' }}>menu_book</i>
              <span style={{ fontSize: '0.8rem' }}>Sermons</span>
            </div>
          </NavLink>

          <NavLink 
            to="/contributions" 
            className={({ isActive }) => 
              `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
            }
            style={{
              background: 'transparent',
              border: 'none',
              padding: '0.5rem 1rem',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <i className="material-icons" style={{ fontSize: '1.5rem' }}>payment</i>
              <span style={{ fontSize: '0.8rem' }}>Giving</span>
            </div>
          </NavLink>

          <NavLink 
            to="/more" 
            className={({ isActive }) => 
              `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
            }
            style={{
              background: 'transparent',
              border: 'none',
              padding: '0.5rem 1rem',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <i className="material-icons" style={{ fontSize: '1.5rem' }}>apps</i>
              <span style={{ fontSize: '0.8rem' }}>More</span>
            </div>
          </NavLink>
        </div>
      </footer>
    </>
  );
}

export default Footer;

// import React from 'react';
// import { NavLink } from 'react-router-dom';

// const Footer = () => {
//   return (
//     <footer style={{ 
//       backgroundColor: '#f8f9fa',
//       position: 'fixed',
//       bottom: 0,
//       width: '100%',
//       padding: '0.5rem 0',
//       boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.05)'
//     }}>
//       <div id="buttonGroup" style={{
//         display: 'flex',
//         justifyContent: 'space-around',
//         maxWidth: '600px',
//         margin: '0 auto'
//       }} role="group" aria-label="Main navigation">
//         <NavLink 
//           to="/home" 
//           className={({ isActive }) => 
//             `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
//           }
//           style={{
//             background: 'transparent',
//             border: 'none',
//             padding: '0.5rem 1rem'
//           }}
//         >
//           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//             <i className="material-icons" style={{ fontSize: '1.5rem' }}>roofing</i>
//             <span style={{ fontSize: '0.8rem' }}>Home</span>
//           </div>
//         </NavLink>

//         {/* Repeat same style pattern for other NavLinks */}
//         <NavLink 
//           to="/sermons" 
//           className={({ isActive }) => 
//             `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
//           }
//           style={{
//             background: 'transparent',
//             border: 'none',
//             padding: '0.5rem 1rem'
//           }}
//         >
//           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//             <i className="material-icons" style={{ fontSize: '1.5rem' }}>menu_book</i>
//             <span style={{ fontSize: '0.8rem' }}>Sermons</span>
//           </div>
//         </NavLink>

//         <NavLink 
//           to="/contributions" 
//           className={({ isActive }) => 
//             `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
//           }
//           style={{
//             background: 'transparent',
//             border: 'none',
//             padding: '0.5rem 1rem'
//           }}
//         >
//           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//             <i className="material-icons" style={{ fontSize: '1.5rem' }}>payment</i>
//             <span style={{ fontSize: '0.8rem' }}>Giving</span>
//           </div>
//         </NavLink>

//         <NavLink 
//           to="/more" 
//           className={({ isActive }) => 
//             `btn btn-secondary ${isActive ? 'button-active' : 'button-inactive'}`
//           }
//           style={{
//             background: 'transparent',
//             border: 'none',
//             padding: '0.5rem 1rem'
//           }}
//         >
//           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//             <i className="material-icons" style={{ fontSize: '1.5rem' }}>apps</i>
//             <span style={{ fontSize: '0.8rem' }}>More</span>
//           </div>
//         </NavLink>
//       </div>
//     </footer>
//   );
// }

// export default Footer;